<script>
  /* global Global, DEV_ENV */
  import HeaderDefault from './HeaderDefault.svelte';
  import HeaderOld from './HeaderOld.svelte';
  import CookiesBar from '../ui-components/CookiesBar.svelte';

  export let page;
  export let lang = undefined;
  export let display = true;
  export let savePage = true;
  export let user = undefined;
  export let mode = undefined;

  let cookies = window.localStorage.getItem('cookies');

  function acceptCookies () {
    cookies = 'accepted';
    window.localStorage.setItem('cookies', cookies);
  }

  function rejectCookies () {
    cookies = 'rejected';
    window.localStorage.setItem('cookies', cookies);
  }

  if (!DEV_ENV) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const f = document.getElementsByTagName('script')[0];
    const j = document.createElement('script');

    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KZGPRF4';

    f.parentNode.insertBefore(j, f);

    function gtag () {
      window.dataLayer.push(arguments);
    }

    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
    });

    if (cookies === 'accepted') {
      gtag('consent', 'update', {
        ad_storage: 'denied',
        analytics_storage: 'granted',
      });
    }
  }

  const projectStyle = Global.project.style;
</script>

{#if projectStyle === 'old'}
  <HeaderOld bind:page bind:lang bind:display bind:savePage bind:user bind:mode/>
{:else}
  <HeaderDefault bind:page bind:lang bind:display bind:savePage bind:user bind:mode/>
{/if}

{#if !cookies}
  <CookiesBar onAccept={acceptCookies} onReject={rejectCookies} bind:lang/>
{/if}
